
import {
  email,
  required,
  minLength
} from "vuelidate/lib/validators";
import errorParseNetwork from "~/helpers/errorParseNetwork";
import {parseUtmLabels} from "~/helpers/formSend";
import transliterate from "~/helpers/transliterate";

export default {
  name: "BackCall",

  computed: {
    isOpen: function () {
      return this.$store.state["back-call-custom"]?.isOpen || false
    },

    options: function () {
      return this.$store.state["back-call-custom"]?.settings || {}
    },

    title: function () {
      return this.options?.title || "Спасибо за обращение!"
    },
    type: function () {
      return this.options?.type || ""
    },
    message: function () {
      return this.options?.message || `Наши менеджеры уже сражаются за возможность позвонить вам.<span>Победитель перезвонит в течение 5 минут</span>`
    }
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        this.setPopUpUrl();
      } else {
        this.removePopUpUrl();
      }
    }
  },

  methods: {
    setPopUpUrl: function () {
      const _popUpKey = ([this.title, this.type].filter((t) => !!t).join("_").toLowerCase() || "").replaceAll(" ", "");
      const popUpKey = transliterate(_popUpKey);
      const currentUrl = new URL(window.location.href);
      let currentSearch = new URLSearchParams(currentUrl.search);
      currentSearch.delete('success-send-form');
      currentSearch.set('success-send-form', popUpKey);
      currentSearch = currentSearch.toString();
      const clearHref = (window.location.href || "").split("?")?.[0] || "";
      const reloadUrl = [clearHref, currentSearch].filter((t) => !!t).join("?");
      window.history.replaceState(null, null, reloadUrl);
    },
    removePopUpUrl: function () {
      const currentUrl = new URL(window.location.href);
      let currentSearch = new URLSearchParams(currentUrl.search);
      currentSearch.delete('success-send-form');
      currentSearch = currentSearch.toString();
      const clearHref = (window.location.href || "").split("?")?.[0] || "";
      const reloadUrl = [clearHref, currentSearch].filter((t) => !!t).join("?");
      window.history.replaceState(null, null, reloadUrl);
    },
    close: function () {
      this.activeTab = "mini";
      this.$store.commit("back-call-custom/setOpen", false);
    },
  }
}
